import {QueryBuilder} from "./QueryBuilder";
import DefaultVariableStrategy from "./DefaultVariableStrategy";
import {DefaultNodeTreeStrategy} from "./DefaultNodeTreeStrategy";

export class DirectTableQueryBuilder {
    /**
     * @param queryName Name of existing Query serverside OR "Table Name" that would be transformed to a Query name guess.
     */
    constructor(queryName, options = {}) {
        this.queryName = queryName;

        if (options.variablesStrategy) {
            this.variablesStrategy = options.variablesStrategy;
        } else {
            this.variablesStrategy = new DefaultVariableStrategy();
        }

        if (options.nodeTreeStrategy) {
            this.nodeTreeStrategy = options.nodeTreeStrategy;
        } else {
            this.nodeTreeStrategy = new DefaultNodeTreeStrategy();
        }
    }

    build(context) {
        // Elementos iniciales
        const queryName = this.queryName;
        const entityName = this.queryName.charAt(0).toUpperCase() + this.queryName.slice(1);

        // Construir la query usando QueryBuilder
        const queryBuilder = new QueryBuilder(queryName, entityName);

        this.variablesStrategy.buildVariables(queryBuilder, context);

        // Agregar campos de retorno
        this.nodeTreeStrategy.buildNodeTree(queryBuilder, context);

        return queryBuilder.build();
    }
}
